import React, { useEffect, useRef } from "react";
import { GET_SERVICES } from "../graphql/queries";
import { useQuery } from "@apollo/client";
import gsap from "gsap";

export default function Services() {
    const { loading, error, data } = useQuery(GET_SERVICES);
    const courseListItemsRefs = useRef([]);

    useEffect(() => {
        if (!loading && !error && data) {
            courseListItemsRefs.current.forEach((itemRef, index) => {
                gsap.fromTo(
                    itemRef,
                    { opacity: 0, y: 20 },
                    { opacity: 1, y: 0, duration: 1, delay: index * 0.2 }
                );
            });
        }
    }, [loading, error, data]);

    if (loading) return <p>Loading...</p>;
    if (error) {
        console.error(error);
        return <p>Error: {error.message}</p>;
    }

    return (
        <div className="main-container">
            <div className="posts-header">
                <div className="post-content">
                    <h1>
                        Welke services
                        <br />
                        bieden wij aan?
                    </h1>
                    <div className="purple-line"></div>
                    <p>
                        In het Graduaat Programmeren leer je programmeren en
                        staat front-end web development centraal. Jouw lessen
                        worden doorspekt met interactieve oefeningen. Je krijgt
                        opdrachten om nieuwe leerstof snel onder de knie te
                        krijgen. Werkplekleren en jouw stage zijn samen goed
                        voor meer dan 1.200 uur aan praktijkervaring. Hierna ben
                        je meer dan klaar voor de arbeidsmarkt.
                    </p>
                </div>
                <ul className="opleidingen">
                    {data.services.map((item, index) => (
                        <div key={item.id} className="opleiding-item">
                            <li>
                                <a href={`#${item.title}`}>{item.title}</a>
                            </li>
                        </div>
                    ))}
                </ul>
            </div>
            <div className="course-list">
                {data.services.map((item, index) => (
                    <div
                        key={item.id}
                        className="opleiding-card"
                        id={item.title}
                        ref={(el) => (courseListItemsRefs.current[index] = el)}
                    >
                        <div className="top-line"></div>
                        <h2>{item.title}</h2>
                        <p>{item.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
